<template>
  <div id="RefundCard" class="transaction">
    <BottomBar />
    <Modal
      v-if="components.help"
      title="关于提现"
      :showClose="true"
      :tapToDismiss="true"
      :showComplete="false"
      v-on:dismiss="components.help = false"
    >
      <Help />
    </Modal>
    <Modal
      v-if="components.name"
      title="真实姓名"
      subtitle="请提供微信支付/银行卡绑定的姓名"
      :showClose="true"
      :tapToDismiss="true"
      :showComplete="false"
      v-on:dismiss="components.name = false"
    >
      <div class="input-wrapper">
        <div class="input">
          <input v-model="name" ref="name" type="text" name="name" placeholder="您的姓名" />
        </div>
        <div @click="getCash" class="button">确认提现</div>
      </div>
    </Modal>
    <Empty
      :loading="data === undefined"
      :icon="true"
      v-if="!data"
      title="无数据"
      subtitle="抱歉，暂时找不到您的提现单"
    />
    <div v-else>
      <Modal
        v-if="components.success"
        title="提现成功"
        subtitle="金额已到账微信零钱"
        :showClose="false"
        :tapToDismiss="false"
        :showComplete="true"
        v-on:complete="components.success = false"
      >
        <p>下次提现，我们将尝试为您自动到账，无需手动操作。</p>
        <br />
      </Modal>
      <div class="head">
        <h1 v-if="data.status !== 5">¥ {{ data.refund_amount }}</h1>
        <h1 v-else>{{ data.course_reward }}</h1>
        <h2 v-if="data.status === 0">
          <span>{{ fromNow(data.start_time) }}后自动到账，或手动提现</span>
        </h2>
        <h2 v-if="data.status === 1">
          <span>您现在可以提现，{{ fromNow(data.end_time) }}内有效</span>
        </h2>
        <h2 v-if="data.status === 2">
          <i class="primary anyteachicon anyteach-check-circle" />
          <span>金额已到账</span>
        </h2>
        <h2 v-if="data.status === 3">
          <i class="anyteachicon anyteach-error2" />
          <span>提现单已失效</span>
        </h2>
        <h2 v-if="data.status === 4">
          <i class="anyteachicon anyteach-error2" />
          <span>相关订单已退款，无法提现</span>
        </h2>
        <h2 v-if="data.status === 5">
          <i class="primary anyteachicon anyteach-check-circle" />
          <span>您已成功兑换课时</span>
        </h2>
      </div>
      <div class="info">
        <div @click="components.help = true" class="help">
          <i class="anyteachicon anyteach-help" />
          <span>关于提现</span>
        </div>
        <Sect title="提现">
          <Row title="类型" :value="types[data.type]" />
          <Row v-if="data.status < 2" title="开始时间" :value="date(data.start_time)" />
          <Row v-if="data.status < 2" title="结束时间" :value="date(data.end_time)" />
          <Row v-if="data.status === 2" title="到账时间" :value="date(data.refund_time)" />
          <Row v-if="data.comments_1" title="备注" :value="data.comments_1" />
        </Sect>
        <Sect title="来源" v-if="data.invited_name">
          <Row v-if="data.invited_name" title="用户">
            <div class="user">
              <div class="img" :style="$bgd(data.invited_gravatar)" />
              <span>{{ data.invited_name }}</span>
            </div>
          </Row>
          <Row v-if="data.v2_course_title" title="购买课程" :value="data.v2_course_title" />
          <Row v-if="data.v2_course_subtitle" title="课程场次" :value="data.v2_course_subtitle" />
          <Row title="支付金额">
            <span v-if="data.status === 4" class="label">已退款</span>
            <span>¥ {{ data.pay_amount }}</span>
          </Row>
          <Row title="支付时间" :value="date(data.pay_time)" />
        </Sect>
      </div>
      <div v-if="data.status == 0" class="button" @click="$toast('请等待提现开始时间')">
        <h1>微信提现</h1>
        <h2>
          <i class="anyteachicon anyteach-wait" />
          {{ fromNow(data.start_time) }}后
        </h2>
      </div>
      <div v-if="data.status == 1">
        <div class="button" @click="components.name = true">
          <h1>微信提现</h1>
          <h2>{{ fromNow(data.end_time) }}内</h2>
        </div>
      </div>
      <router-link to="/cash" tag="div" class="text-link">查看更多提现单</router-link>
    </div>
  </div>
</template>
<script>
import Sect from "./Sect"
import Row from "./Row"
import { fromNow, date } from "./utils"
import Help from "./Help"

export default {
  name: "RefundCard",
  props: ["id"],
  components: {
    Sect,
    Row,
    Help
  },
  data() {
    return {
      data: undefined,
      components: {
        name: false,
        success: false,
        help: false
      },
      name: "",
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    types() {
      return this.$store.state.info.refund
    },
  },
  watch: {
    "components.name": function (val) {
      if (val) {
        this.$nextTick(() => this.$refs.name.focus())
      }
    },
    user: {
      immediate: true,
      handler: function (val) {
        if (!val) return null
        if (this.user.real_name && !this.name.length) {
          this.name = this.user.real_name
        }
        this.getHelpStatus()
      },
    }
  },
  created() {
    this.wxShare()
    this.getData()
    // if (this.$route.query.event === "name" || this.$route.query.event === "error") {
    //   this.components.help = true
    // }
  },
  methods: {
    fromNow,
    date,
    getHelpStatus() {
      const key = "cash_help"
      const keyExists = Object.keys(localStorage).includes(key)
      const today = this.$moment().format("YYYY-MM-DD HH:mm:ss")
      if (!keyExists && !this.user.real_name) {
        this.components.help = true
        localStorage.setItem(key, today)
      }
    },
    wxShare() {
      wx.ready(() => {
        this.$wxShare({
          title: `${window.document.title}`,
          imgUrl: window.logo2019,
          desc: "查看你的现金奖励，最高上千元。",
          link: window.homePageUrl + "/cash"
        })
      })
    },
    async getData() {
      const res = await this.$api.order.CASH_LIST(this.id)
      this.data = res.length ? res[0] : null
    },
    async getCash() {
      if (!this.name.length) {
        return this.$toastError("请提供真实姓名")
      }
      this.$toastLoading("正在提取现金")

      try {
        const { code, msg } = await this.$api.refund.GET_CASH({
          id: this.data.id,
          name: this.name,
        })

        if (code === "1000") {
          this.getData()
          this.components.name = false
          // this.$toastSuccess("提现成功，已到账微信")
          this.$toastHide()
          this.components.success = true
        } else {
          this.$toastError(`${msg} ${code}`)
        }
      } catch (error) {
        this.$toastError(error)
      }
    },
  },
}
</script>
<style scoped lang="scss">
@import "./style.scss";
@import "../../../static/css/transaction.scss";

#RefundCard {
  font-family: Avenir, -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji,
    Segoe UI Symbol;
  padding-bottom: $bottom-bar;
  background: white;

  .empty {
    background: none;
    height: 75vh;
  }
  .disabled {
    opacity: 1;
  }
  .head {
    padding-top: 60px;
  }
  .button {
    color: white;
    width: 90%;
    margin: 15px auto 10px auto;
    padding: 10px 0;
    background: $primary;
  }

  .text-link {
    text-align: center;
    color: $primary;
    transition: all 0.1s;
    font-size: 0.85rem;
    margin: 0 0 -5px;
    padding: 0;
    &:active {
      opacity: 0.6;
    }
  }
  .input-wrapper {
    margin: 0 0 20px 0;
    * {
      line-height: 1;
    }
    &:last-of-type {
      margin: 0 0 5px 0;
    }
    h3 {
      font-size: 0.8rem;
      @include avenir-demi();
    }
    .button {
      width: 100%;
    }
    .input {
      border: 2px solid #eee;
      border-radius: 4px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      transition: all 0.1s;
      span {
        @include avenir();
        margin: 0;
        padding: 0 5px 0 0;
        font-size: 0.9rem;
        opacity: 0.6;
        line-height: normal;
      }
      input {
        border: none;
        margin: 0;
        padding: 0;
        font-size: 0.9rem;
        @include avenir-demi();
        &::-webkit-input-placeholder,
        &::placeholder {
          line-height: normal;
          @include avenir();
          font-weight: 400;
          margin: 0;
          padding: 0;
        }
      }
    }
    .active {
      border-color: $primary;
      box-shadow: 0 0 5px rgba(1, 131, 255, 0.5);
    }
  }
}

.info {
  border: $border;
  border-radius: 4px;
  width: 75%;
  min-width: 250px;
  margin: 15px auto;
  padding: 10px;
  background: white;
  box-shadow: $deep-shadow;
  position: relative;
  .help {
    position: absolute;
    right: 10px;
    top: 10px;
  }
  .label {
    display: inline-block;
    border: 1px solid $grey;
    border-radius: 3px;
    font-weight: 400;
    font-size: 12px;
    text-align: center;
    padding: 0 3px;
    transform: scale(0.9);
    transform-origin: top;
    margin: 0 3px 0 0;
    line-height: 1.5;
  }
  .info-item {
    display: flex;
    justify-content: space-between;
    padding: 0 0 5px 0;
    font-size: 0.9rem;
    &:last-of-type {
      padding: 0;
    }
    .left {
      opacity: 0.6;
      min-width: 60px;
    }
    .right {
      text-align: right;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .right,
    code {
      -o-user-select: text;
      -moz-user-select: text;
      -webkit-user-select: text;
      user-select: text;
    }
    .copy {
      &:active {
        i {
          opacity: 0.6;
        }
      }
      i {
        margin-left: 5px;
        transition: all 0.1s;
        &:active {
          opacity: 0.6;
        }
      }
    }
  }
}
</style>
